import React from "react";
import styles from "../../styles/landing.module.css";

const GoogleCalendarSection = () => {
  return (
    <section className={styles.googleCalendarSection}>
      <div className={styles.googleCalendarContent}>
        <div className={styles.googleCalendarText}>
          <div className={styles.sectionTitleWithLogo}>
            <img 
              src="/gCalendar.png" 
              alt="Google Calendar Logo" 
              className={styles.titleLogo}
            />
            <h2>Google Calendar Synchronization</h2>
          </div>
          <p>
            Perfectly integrate your revision sessions into your daily schedule.
            Memory Curve synchronizes with Google Calendar to help you:
          </p>
          <ul>
            <li>Receive automatic reminders for your revision sessions</li>
            <li>Easily visualize your revision schedule in your regular calendar</li>
            <li>Manage your availability and adapt your revision plan</li>
            <li>Access your revision schedule on all your devices</li>
          </ul>
          <p>
            No more juggling between multiple applications to manage your study time!
          </p>
        </div>
        
        <div className={styles.googleCalendarImage}>
          <img 
            src="/calendar.png" 
            alt="Google Calendar Integration" 
            className={styles.sectionImage}
          />
          <p className={styles.imageCaption}>
            Your revision sessions appear directly in your Google Calendar with smart alerts
          </p>
        </div>
      </div>
    </section>
  );
};

export default GoogleCalendarSection; 